export const Stars = ({rating, size=12}) => (
  <div style={{display:"flex",alignItems:"center",gap:2}}>
    {[1,2,3,4,5].map(s=><svg key={s} width={size} height={size} viewBox="0 0 24 24" fill={s<=Math.round(rating)?"#F5A623":"#DDD8D0"}><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>)}
    <span style={{color:"#C17F3B",fontSize:size,fontWeight:700,marginLeft:4}}>{rating}</span>
  </div>
);
